<ng-container *ngIf="!isMobile">
  <header class="header" [class.add-sti]="isSticky">
    <ion-row class="box-container">
      <ion-col>
        <ion-row class="top-header">
          <ion-col size="auto" class="top-location">
            <span><img src="../../../assets/icon/location.svg" alt="location"/> {{topHeader?.address}}</span>
          </ion-col>
          <ion-col></ion-col>
          <ion-col size="auto" class="top-call">
            <span><img src="../../../assets/icon/call.svg" alt="call"/> {{topHeader?.phone}}</span>
          </ion-col>
        </ion-row>
        <ion-row class="main-header">
          <ion-col size="auto">
            <div routerLink="/" class="logo-holder">
              <img src="/assets/img/logo.png" alt="logo abrame">
            </div>
          </ion-col>
          <ion-col class="main-menu-holder">
            <ion-row class="main-menu-inner">
              <ion-col class="main-menu" (mouseenter)="headerOpen=false"><a routerLink="/">Home</a></ion-col>
              <ion-col class="main-menu" (mouseenter)="openProductsMenu()"><a routerLink="/products" (click)="openProductsMenu()">Products</a></ion-col>
              <ion-col class="main-menu" (mouseenter)="headerOpen=false"><a routerLink="/about">About</a></ion-col>
              <ion-col class="main-menu" (mouseenter)="headerOpen=false" *ngIf="!appInitData" (click)="openProfile()">Trade</ion-col>
              <ion-col class="main-menu" (mouseenter)="headerOpen=false"><a href="{{topHeader?.catalog_url}}">Catalog</a></ion-col>
            </ion-row>
          </ion-col>
          <ion-col size="auto" class="right-header">
            <a class="instagram-header" href="https://www.instagram.com/arbamecorp/" target="_blank" rel="noopener noreferrer" aria-label="ARBAME on Instagram (opens in a new tab)" title="ARBAME on Instagram">
              <img src="/assets/icon/instagram.svg" alt="" aria-hidden="true" />
            </a>
            <div (click)="showSearch=true" class="header-icon search-header">
              <img src="../../../assets/icon/search-normal.svg" alt="search"/>
            </div>

            <div class="input-search-simple animate__animated animate__fadeIn animate__faster" *ngIf="showSearch">
              <ion-input placeholder="Search keyword, title , ..." [(ngModel)]="searchInput" (ngModelChange)="inputSearchChanged($event)"></ion-input>
              <img src="/assets/icon/search-d.svg" alt="search icon"/>
              <div class="result-box">
                <ion-spinner *ngIf="loadSearching" name="crescent"></ion-spinner>
                <div *ngIf="searchResult?.data?.search_count && !loadSearching" class="count-result">
                  {{searchResult?.data?.search_count}} results
                </div>
                <div class="result-list" *ngIf="!loadSearching">
                  <ul>
                    <li (click)="redirectToProduct(item)" *ngFor="let item of searchResult?.data?.product_groups">
                      <img src="{{item?.file?.thumb_url}}"/>
                      <h4>{{item.title}}</h4>
                      <!--                      <span>Collection</span>-->
                    </li>
                  </ul>
                  <ion-button *ngIf="searchResult?.data?.product_groups?.length>0" (click)="redirectToSearch()" class="view-all-simple-search">View All</ion-button>
                </div>
              </div>
            </div>
            <div class="header-icon profile-header" (click)="openProfile()">
              <img src="../../../assets/icon/profile-circle.svg" alt="user"/>
            </div>
            <div class="header-icon basket-header" (click)="openCart()">
              <span class="cart-badge animate__animated" [class.animate__fadeIn]="animateBadge" *ngIf="basketCount">{{basketCount}}</span>
              <img src="../../../assets/icon/shopping-cart.svg" alt="basket"/>
            </div>
          </ion-col>
        </ion-row>


      </ion-col>
    </ion-row>
    <div *ngIf="headerOpen" class="product-section box-container">
      <ion-row class="product-section-inner">
        <ion-col size="3" class="mega-cat-col">
          <div class="mega-cat-parent">
            <a class="each-mega-cat"
               [class.active]="selectedCatalog?.alias === item?.alias"
               (mouseenter)="selectedCatalog=item"
               *ngFor="let item of menuData?.data"
               routerLink="/products/{{item?.alias}}/collection"
               (click)="headerOpen=false">
              {{item.title}}
            </a>
          </div>
        </ion-col>
        <ion-col class="mega-collections-col">
          <div class="mega-collections-parent">
            <ion-row>
              <ion-col size="4" *ngFor="let item of selectedCatalog?.collections">
                <div class="each-mega-collection">
                  <a routerLink="/products/{{selectedCatalog?.alias}}/{{item.alias}}" (click)="headerOpen=false">
                    <!--                  <img src="{{item.img}}" alt="">-->
                    <p>{{item.title}}</p>
                  </a>
                </div>
              </ion-col>
              <ion-col size="12" *ngIf="!selectedCatalog?.collections || selectedCatalog?.collections?.length === 0">
                <div class="no-collections">
                  <p>No collections available</p>
                </div>
              </ion-col>
            </ion-row>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </header>
</ng-container>

<ng-container *ngIf="isMobile">
  <header class="header" [class.add-sti]="isSticky">
    <ion-row class="box-container">
      <ion-col>
        <ion-row class="top-header">
          <ion-col size="auto" class="top-location">
            <a href="{{topHeader?.catalog_url}}" target="_blank"><img src="../../../assets/icon/catalog.svg" alt="catalog"/>Download Catalog </a>
          </ion-col>
          <ion-col></ion-col>
          <ion-col size="auto" class="top-call">
            <a href="tel:+16479870778"><img src="../../../assets/icon/call.svg" alt="call"/> {{topHeader?.phone}}</a>
          </ion-col>
        </ion-row>
        <ion-row class="main-header">
          <ion-col size="auto">
            <div routerLink="/" class="logo-holder">
              <img src="/assets/img/logo.png" alt="logo abrame">
            </div>
          </ion-col>
          <ion-col></ion-col>
          <ion-col size="auto" class="mobile-instagram">
            <a class="instagram-header" href="https://www.instagram.com/arbamecorp/" target="_blank" rel="noopener noreferrer" aria-label="ARBAME on Instagram (opens in a new tab)" title="ARBAME on Instagram">
              <img src="/assets/icon/instagram.svg" alt="" aria-hidden="true" />
            </a>
          </ion-col>
          <ion-col id="main-content" class="burger-menu" size="auto">
            <ion-menu-toggle>
              <img src="../../../assets/icon/menu.svg" alt="menu"/>
            </ion-menu-toggle>
          </ion-col>
        </ion-row>

      </ion-col>
    </ion-row>
  </header>
</ng-container>

<ion-menu #mainMenu *ngIf="isMobile" [swipeGesture]="false" side="end" contentId="main-content" menuId="hamburger-menu">
  <ion-row class="top-mobile-menu">
    <ion-col>
      <h3>Menu</h3>
    </ion-col>
    <ion-col size="auto" (click)="mainMenu.close()">
      <img src="../../../assets/icon/close.svg" alt="close"/>
    </ion-col>
  </ion-row>
  <ion-row class="burger-menu-content">
    <ion-col size="auto" class="burger-menu-mobile">
      <ion-row class="main-menu-inner">
        <ion-col class="main-menu-mobile"><a (click)="mainMenu.close()" routerLink="/">Home</a></ion-col>
        <ion-col class="main-menu-mobile" (click)="mainMenu.close()"><a routerLink="/products" (click)="headerOpen=true">Products</a></ion-col>
        <ion-col class="main-menu-mobile"><a (click)="mainMenu.close()" routerLink="/about">Our story</a></ion-col>
        <ion-col class="main-menu-mobile trade-item" *ngIf="!appInitData" (click)="openProfile();mainMenu.close()">Trade</ion-col>
        <ion-col class="main-menu-mobile"><a (click)="mainMenu.close()" href="{{topHeader?.catalog_url}}">Catalog</a></ion-col>
        <ion-col class="main-menu-mobile"><a (click)="mainMenu.close()" routerLink="/contact">Contact us</a></ion-col>
      </ion-row>
    </ion-col>
  </ion-row>
</ion-menu>
<div *ngIf="headerOpen && !isMobile" (mouseenter)="headerOpen=false" (click)="headerOpen=false" class="product-section-backdrop">
</div>
<div *ngIf="showSearch&& !isMobile" (click)="showSearch=false" class="search-backdrop">
</div>
<div class="mini-card-container animate__animated  animate__faster" [class.animate__fadeInRight]="cartOpen" [class.animate__fadeOutRight]="!cartOpen">
  <app-mini-cart (closeMenu)="cartOpen=false"></app-mini-cart>
</div>
<div *ngIf="cartOpen && !isMobile" (click)="cartOpen=false" class="mini-card-backdrop"></div>
